import { ScreenState } from "./screen";

export class Drawable{
  width = undefined;
  height = undefined;
  initTime = /** @type {number | undefined} */ (undefined);
  /**
  * Initialiases the drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */
  constructor(x, y, configureCanvas){
    this.x = x;
    this.y = y;
    this.configureCanvas = configureCanvas === false ? false : true;
    this.destroyed = false;
  }

  /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  configure(screenState){}

  /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  render(screenState) {
    if (!this.initTime){
      this.initTime = screenState.animationStep
    }
    if (this.configureCanvas){
      this.configure(screenState);
    }
  }

  destroy(){
    this.destroyed = true;
  }
}



export class DummyDrawable extends Drawable{
  /**
  * Initialiases the Dummy drawable.
  * @param {number} x A positive number indicating x coordinate on screen
  * @param {number} y A positive number indicating y coordinate on screen
  * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
  */
  constructor(x, y, configureCanvas){
    super(x, y, configureCanvas);
  }

  /**
  * Configures the canvas to render the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  configure(screenState){
  }

  /**
  * Renders the drawable.
  * @param {ScreenState} screenState The current state of the screen
  */
  render(screenState) {
    super.render(screenState);
  }
}


// export class AnimatedDrawable extends Drawable{
//   _animationProgress = /** @type {number} */ (0);
//   animationStartTimestamp = /** @type {number | null} */ (null);

//   /**
//   * Initialiases the animateable drawable.
//   * @param {number} x A positive number indicating x coordinate on screen
//   * @param {number} y A positive number indicating y coordinate on screen
//   * @param {number} [forwardAnimationDuration=2000] Duration of Forward Animation in milliseconds
//   * @param {number} [reverseAnimationDuration=2000] Duration of Forward Animation in milliseconds
//   * @param {number} [cycleAnimation=0] How many times to cycle between forward and reverse animation, set to -1 for infinite
//   * @param {'forward'|'reverse'} [animationDirection='forward'] Starting direction of animation
//   * @param {boolean} [configureCanvas=true] Whether to configure canvas before render
//   */
//   constructor(x, y, forwardAnimationDuration, reverseAnimationDuration, cycleAnimation, animationDirection, configureCanvas){
//     super(x, y, configureCanvas);
//     this.forwardAnimationDuration = forwardAnimationDuration || 2000;
//     this.reverseAnimationDuration = reverseAnimationDuration || 2000;
//     this.cycleAnimation = cycleAnimation || 0;
//     this.animationDirection = animationDirection || 'forward';
//     this.animationCyclesCompleted = 0;
//   }

//   set animationProgress(value){
//     if (value > 1){
//       if (this.cycleAnimation < 0 || this.animationCyclesCompleted < this.cycleAnimation){
//         this._animationProgress = 0;
//         this.animationStartTimestamp = null;
//         this.animationDirection = this.animationDirection === 'forward' ? 'reverse': 'forward';
//         this.animationCyclesCompleted++;
//       }
//       else{
//         this._animationProgress = 1
//       }
//     }
//     else{
//       this._animationProgress = value
//     }
//   }

//   get animationProgress(){
//     return this._animationProgress
//   }


//   /**
//   * Renders the drawable for forward animation
//   * @param {CanvasRenderingContext2D} canvasCtx The HTML canvas 2D rendering context
//   * @param {number} animationProgress A positive number from 0 to 1 indicating current animation progress.
//   */
//   forwardAnimationRender(canvasCtx, animationProgress){}


//   /**
//   * Renders the drawable for reverse animation
//   * @param {CanvasRenderingContext2D} canvasCtx The HTML canvas 2D rendering context
//   * @param {number} animationProgress A positive number from 0 to 1 indicating current animation progress.
//   */
//   reverseAnimationRender(canvasCtx, animationProgress){}


//   /**
//   * Renders the drawable.
//   * @param {CanvasRenderingContext2D} canvasCtx The HTML canvas 2D rendering context
//   * @param {number} animationStep A positive number indicating current animation timeline
//   */
//   render(canvasCtx, animationStep) {
//     super.render(canvasCtx, animationStep);
//     if (!this.animationStartTimestamp){
//       this.animationStartTimestamp = animationStep;
//     }
//     if (this.animationDirection === 'forward'){
//       this.animationProgress = (animationStep - this.animationStartTimestamp)/this.forwardAnimationDuration;
//       this.forwardAnimationRender(canvasCtx, this.animationProgress);
//     }
//     else if (this.animationDirection === 'reverse'){
//       this.animationProgress = (animationStep - this.animationStartTimestamp)/this.reverseAnimationDuration;
//       this.reverseAnimationRender(canvasCtx, this.animationProgress);
//     }
//   }
// }

